import React from 'react';
import { MainNavigationNavItem } from '../NavItems/MainNavigationNavItem';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { NavItem } from '../../../../types/api/NavItem';
import { FetchSubPanel, GroupLabels } from '../../MainNavigationTypes';

type NavigationListType = {
  navItems: NavItem[];
  groupLabel?: GroupLabels;
  fetchSubPanel?: FetchSubPanel;
  panelLevel?: number;
  activeOpenButtonId?: string;
  setActiveOpenButtonId?: (activeOpenButtonId: string | undefined) => void;
};
export function NavigationList({
  navItems,
  groupLabel,
  fetchSubPanel,
  panelLevel,
  activeOpenButtonId,
  setActiveOpenButtonId,
}: NavigationListType) {
  const { t } = useSonTranslation('MainNavigation');

  if (navItems?.length > 0) {
    return (
      <ul className="main-navigation__list" aria-label={groupLabel ? t(`groupLabel.${groupLabel}`) : undefined}>
        {navItems.map(item => (
          <MainNavigationNavItem
            navItem={item}
            key={item.link.url}
            fetchSubPanel={fetchSubPanel}
            panelLevel={panelLevel}
            activeOpenButtonId={activeOpenButtonId}
            setActiveOpenButtonId={setActiveOpenButtonId}
          />
        ))}
      </ul>
    );
  }
  return null;
}
